import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Services() {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const services = [
    {
      id: 'returns',
      title: '반품관리',
      description: '체계적인 반품 처리 시스템으로 고객 만족도를 높이고 재판매 가능한 상품의 손실을 최소화합니다.',
      features: [
        '신속한 반품 접수 및 처리',
        '상품 상태 정밀 검수',
        '재판매 가능 상품 분류',
        '고객 환불/교환 처리',
        '반품 데이터 분석 리포트'
      ],
      videoUrl: 'https://drive.google.com/file/d/13suPqzPcOW1twLNiijPji9cSZL5cVr2z/preview',
      icon: 'ri-arrow-go-back-line',
      bgColor: 'from-blue-50 to-blue-100',
      iconColor: 'bg-blue-600',
      imageUrl: 'https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/933746d53bc4c2e8c33a4e91ab4ddf8f.jpeg'
    },
    {
      id: 'sorting',
      title: '소분작업 전문성',
      description: '다양한 상품의 특성에 맞는 전문적인 소분 작업으로 효율적인 재고 관리와 배송을 지원합니다.',
      features: [
        '상품별 맞춤 소분 작업',
        '정확한 수량 관리',
        '효율적인 포장 단위 최적화',
        '바코드 기반 추적 시스템',
        '실시간 작업 현황 모니터링'
      ],
      videoUrl: 'https://drive.google.com/file/d/1JhDv_s5Wy4yhFrb3fjNVmIV2wxMIEMd_/preview',
      icon: 'ri-scissors-cut-line',
      bgColor: 'from-green-50 to-green-100',
      iconColor: 'bg-green-600',
      imageUrl: 'https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/e4dc6bde6cb728d406b42423819c8ebf.jpeg'
    },
    {
      id: 'packaging',
      title: '포장 품질관리',
      description: '완벽한 포장 품질 관리로 상품의 안전한 배송과 고객 만족을 보장합니다.',
      features: [
        '상품별 최적 포장재 선택',
        '파손 방지 전문 포장',
        '브랜드 맞춤 포장 서비스',
        '포장 품질 검수 시스템',
        '친환경 포장재 사용'
      ],
      videoUrl: 'https://drive.google.com/file/d/1KkWuhPeXz3jlj5BBIRfooMPEaMJAJJb2/preview',
      icon: 'ri-gift-line',
      bgColor: 'from-orange-50 to-orange-100',
      iconColor: 'bg-orange-600',
      imageUrl: 'https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/721346b556236de071cbbaa68f561e02.jpeg'
    }
  ];

  const closeModal = () => {
    setSelectedVideo(null);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-[50vh] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('https://public.readdy.ai/ai/img_res/d916da59feee17d2cdfaed8d76fc8d28.jpg')`
        }}
      >
        <div className="max-w-6xl mx-auto px-4 text-center text-white">
          <h1 className="text-5xl font-bold mb-8">전문 서비스 소개</h1>
          <p className="text-2xl mb-12 leading-relaxed font-semibold">
            올딩스 로지스만의 차별화된 3가지 핵심 서비스
          </p>
          <p className="text-xl font-medium">
            반품관리 · 소분작업 · 포장품질관리
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              핵심 서비스
            </h2>
            <p className="text-xl text-gray-600">
              고객의 성공을 위한 올딩스 로지스의 전문 서비스를 확인해보세요
            </p>
          </div>

          <div className="space-y-16">
            {services.map((service, index) => (
              <div key={service.id} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
                {/* Service Content */}
                <div className="flex-1">
                  <div className={`bg-gradient-to-br ${service.bgColor} rounded-2xl p-8`}>
                    <div className="flex items-center mb-6">
                      <div className={`w-16 h-16 ${service.iconColor} rounded-full flex items-center justify-center mr-4`}>
                        <i className={`${service.icon} text-2xl text-white`}></i>
                      </div>
                      <h3 className="text-3xl font-bold text-gray-900">{service.title}</h3>
                    </div>
                    
                    <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                      {service.description}
                    </p>
                    
                    <div className="space-y-3">
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center">
                          <i className="ri-check-line text-green-600 text-xl mr-3"></i>
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Video Section */}
                <div className="flex-1">
                  <div className="relative bg-gray-100 rounded-2xl overflow-hidden shadow-lg">
                    <div className="aspect-video relative">
                      <iframe
                        src={service.videoUrl}
                        title={`${service.title} 서비스 영상`}
                        className="w-full h-full"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              왜 올딩스 로지스인가?
            </h2>
            <p className="text-xl text-gray-600">
              차별화된 서비스로 고객의 성공을 함께 만들어갑니다
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">전문성</h3>
              <p className="text-gray-600">각 분야별 전문 인력과 시스템</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">신속성</h3>
              <p className="text-gray-600">빠르고 정확한 처리 시스템</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">안전성</h3>
              <p className="text-gray-600">완벽한 품질 관리 시스템</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">고객지원</h3>
              <p className="text-gray-600">24시간 고객 지원 서비스</p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="relative w-full max-w-4xl">
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            <div className="aspect-video bg-black rounded-lg overflow-hidden">
              <iframe
                src={selectedVideo}
                title="Service Video"
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
